export default __webpack_public_path__ + "static/media/icon_nav_close.f688f5cd.svg";